import { headingTagsOverlap } from './heading-common';

export default function () {
  const el = document.querySelector('.article-press-wrapper');
  if (!el) return;

  headingTagsOverlap();
}
